import { Suspense, useRef, useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Accordion from "../../../../../components/Accordion/Accordion";
import SwalAlert from "../../../../../services/swalService/SwalService";
import FormCreator from "../../../../../components/Forms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";
import DataLoader from "../../../../../components/ui/dataLoader/DataLoader";
import { useGetAllRequirementListForSectionAMutation, useGetAllRequirementListForSectionBMutation, useGetAllRequirementListForSectionCMutation, useLazyGetAllDropdownForCRUDCategoryQuery, useLazyGetSGBPCriteriaDetailsByIdQuery, useSubmitCriteriaInFormationMutation, useUpdateCriteriaDetailsMutation } from "../../../../../app/services/Crud/crudApi";
import { EditCriteriaData } from "./data/EditCriteria.data";
import { setAllDropDownField } from "./utils/dropdownUtils";
import { getAuthProps } from "../../../../../lib/authenticationLibrary";
import { decryptAESID } from "../../../../../utils/Encryption";



const Section = ({ 
  title, 
  data,
  searchText,
  handleSearch,
  renderList,
  listRefs,
  handleAssign,
  handleUnassign
}) => (
  <div className="requirement-section">
    <div className="req-box">
      <h4 className="section-title">{title}</h4>
      <p className="sub-title">Approved Requirements</p>
      <div className="list-box">
        <input
          type="text"
          placeholder="Search"
          className="search"
          value={searchText[title]?.approved}
          onChange={(e) => handleSearch(title, "approved", e.target.value)}
        />
        {/* <ul>{renderList(title, "approved", data?.approved)}</ul> */}
        <ul ref={(el) => { if (el) listRefs.current[`${title}-approved`] = el; }}>
          {renderList(title, "approved", data?.approved)}
        </ul>
      </div>
    </div>

    <div className="action-buttons">
      <Buttons buttonText="Assign ›" buttonTypeClassName="assign-btn" onClick={() => handleAssign(title)} />
      <Buttons buttonText="‹ Unassign" buttonTypeClassName="unassign-btn" onClick={() => handleUnassign(title)} />
    </div>

    <div className="req-box">
      <h4 className="count">Count: {data?.assigned?.length}</h4>
      <p className="sub-title">Assigned Requirements</p>
      <div className="list-box">
        <input
          type="text"
          placeholder="Search"
          className="search"
          value={searchText[title]?.assigned}
          onChange={(e) => handleSearch(title, "assigned", e.target.value)}
        />
        {/* <ul>{renderList(title, "assigned", data?.assigned)}</ul> */}

        <ul ref={(el) => { if (el) listRefs.current[`${title}-assigned`] = el; }}>
        {renderList(
          title,
          "assigned",
          data?.assigned?.filter((item) =>
            item.name
            ?.toLowerCase()
            .includes((searchText[title]?.assigned || "").toLowerCase())
          )
        )}
        </ul>
      </div>
    </div>
  </div>
);


const EditCriteria = () => {
  const editCriteriaRefs = useRef();
  const navigate = useNavigate();
  const { id } = useParams();
  const editID = useMemo(() => (id ? decryptAESID(id, false) : 0), [id]);
  const [formData, setFormData] = useState(EditCriteriaData);
  const [channel, setChannel] = useState(null);
  const { success, error, } = SwalAlert()
  const [getAllRequirementListForSectionA] = useGetAllRequirementListForSectionAMutation();
  const [getAllRequirementListForSectionB] = useGetAllRequirementListForSectionBMutation();
  const [getAllRequirementListForSectionC] = useGetAllRequirementListForSectionCMutation();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [submitCriteria, { data: criteriaData, isLoading: criteriaLoading },] = useUpdateCriteriaDetailsMutation();
  const [getSGBPCriteriaDetails, { data: criteriaDetails, isLoading: criteriaDetailsLoading },] = useLazyGetSGBPCriteriaDetailsByIdQuery();
  const listRefs = useRef({});

  const preserveScroll = (key, callback) => {
    const el = listRefs.current[key];
    const scrollTop = el?.scrollTop || 0;
    callback();
    setTimeout(() => {
      if (listRefs.current[key]) {
        listRefs.current[key].scrollTop = scrollTop;
      }
    }, 0);
  };

  const [selectedIdsMap, setSelectedIdsMap] = useState({
    "Section A": [],
    "Section B": [],
    "Section C": [],
  });

  const [sections, setSections] = useState({
    "Section A": { approved: [], assigned: [] },
    "Section B": { approved: [], assigned: [] },
    "Section C": { approved: [], assigned: [] },
  });

  const [searchText, setSearchText] = useState({
    "Section A": { approved: "", assigned: "" },
    "Section B": { approved: "", assigned: "" },
    "Section C": { approved: "", assigned: "" },
  });

  const [ratings, setRatings] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
  });

  const handleFormFieldChange = (field, value) => {
    if (field === "channel") {
      setChannel(value?.value);
      fetchSectionA("", value?.value);
      fetchSectionB("", value?.value);
      fetchSectionC("", value?.value);
      setRatings({
        1: 0,
        2: 0,
        3: 0,
        4: 0,
      });
    }
  }


  useEffect(() => {
    getDropdowns();
  }, []);

  useEffect(() => {
    if (id) {
      getSGBPCriteriaDetails(editID);
    }
  }, [id]);

  const fetchSection = (apiCall, section, search, channelId, selectedIds = []) => {
    if (typeof apiCall !== "function") {
      console.error("Invalid apiCall:", apiCall);
      return;
    }
    apiCall({ RequirementName: search, channelId })
      .unwrap()
      .then((response) => {
        const allItems = (response || []).map((item) => ({
          id: item?.sgbpRequirementId,
          name: item?.requirementName,
          selected: false,
        }));

        // Split into assigned & approved
        setSections((prev) => {
          const assigned =
            prev[section]?.assigned?.length > 0
              ? prev[section].assigned
              : allItems.filter((item) =>
                  selectedIds?.some((id) => Number(id) === Number(item.id))
                );
        
          const approved = allItems.filter(
            (item) =>
              !assigned.some((x) => Number(x.id) === Number(item.id))
          );
        
          return {
            ...prev,
            [section]: {
              approved,
              assigned,
            },
          };
        });

        
      })
      .catch((err) => console.error(`Error in ${section}:`, err));
  };

  const fetchSectionA = (search, channelId) => fetchSection(getAllRequirementListForSectionA, "Section A", search, channelId, selectedIdsMap["Section A"]);
  const fetchSectionB = (search, channelId) => fetchSection(getAllRequirementListForSectionB, "Section B", search, channelId, selectedIdsMap["Section B"]);
  const fetchSectionC = (search, channelId) => fetchSection(getAllRequirementListForSectionC, "Section C", search, channelId, selectedIdsMap["Section C"]);

  useEffect(() => {
    if (!criteriaDetailsLoading && criteriaDetails) {
      const requirementList = criteriaDetails?.requirementList || [];
      const initialData = EditCriteriaData.initialState;
      initialData.channel = criteriaDetails?.channelId || criteriaDetails?.channelId?.value;
      initialData.criteriaName = criteriaDetails?.criteriaName || null;
      const sectionAIds = requirementList.filter(x => x.sectionId === 1).map(x => x.sgbpRequirementId);
      const sectionBIds = requirementList.filter(x => x.sectionId === 2).map(x => x.sgbpRequirementId);
      const sectionCIds = requirementList.filter(x => x.sectionId === 3).map(x => x.sgbpRequirementId);
      setSelectedIdsMap({
        "Section A": sectionAIds,
        "Section B": sectionBIds,
        "Section C": sectionCIds,
      });

      setChannel(criteriaDetails?.channelId);
      fetchSection(getAllRequirementListForSectionA, "Section A", "", criteriaDetails?.channelId, sectionAIds);
      fetchSection(getAllRequirementListForSectionB, "Section B", "", criteriaDetails?.channelId, sectionBIds);
      fetchSection(getAllRequirementListForSectionC, "Section C", "", criteriaDetails?.channelId, sectionCIds);
      setRatings({
        1: criteriaDetails?.rating1Tick ?? 0,
        2: criteriaDetails?.rating2Tick ?? 0,
        3: criteriaDetails?.rating3Tick ?? 0,
        4: criteriaDetails?.rating4Tick ?? 0,
      });
    }
  }, [criteriaDetailsLoading, criteriaDetails]);

  const handleSearch = (section, type, value) => {
    setSearchText((prev) => ({
      ...prev,
      [section]: { ...prev[section], [type]: value },
    }));

    if (type === "approved") {
      if (section === "Section A") fetchSectionA(value, channel);
      if (section === "Section B") fetchSectionB(value, channel);
      if (section === "Section C") fetchSectionC(value, channel);
    }
  };

  // const handleAssign = (section) => {
  //   const approved = [...sections[section].approved];
  //   const assigned = [...sections[section].assigned];

  //   const toAssign = approved.filter((item) => item.selected);
  //   if (!toAssign.length) return;

  //   const newApproved = approved.filter((item) => !item.selected);
  //   const newAssigned = [...toAssign.map(i => ({ ...i, selected: false })), ...assigned];

  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: { approved: newApproved, assigned: newAssigned },
  //   }));
  // };

  const handleAssign = (section) => {
    const key = `${section}-approved`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toAssign = approved.filter((item) => item.selected);
      if (!toAssign.length) return;
      const newApproved = approved.filter((item) => !item.selected);
      const newAssigned = [...assigned,...toAssign.map(i => ({ ...i, selected: false }))];
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));
    });
  };

  const handleUnassign = (section) => {
    const key = `${section}-assigned`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toUnassign = assigned.filter((item) => item.selected);
      if (!toUnassign.length) return;
      const newAssigned = assigned.filter((item) => !item.selected);
      const newApproved = [...toUnassign.map(i => ({ ...i, selected: false })), ...approved];
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));
      if (section == "Section C") {
        setRatings({ 1: 0, 2: 0, 3: 0, 4: 0, });
      }
    });
  };


  // const handleUnassign = (section) => {
  //   const approved = [...sections[section].approved];
  //   const assigned = [...sections[section].assigned];

  //   const toUnassign = assigned.filter((item) => item.selected);
  //   if (!toUnassign.length) return;

  //   const newAssigned = assigned.filter((item) => !item.selected);
  //   const newApproved = [...toUnassign.map(i => ({ ...i, selected: false })), ...approved];

  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: { approved: newApproved, assigned: newAssigned },
  //   }));
  //   if (section == "Section C") {
  //     setRatings({
  //       1: 0,
  //       2: 0,
  //       3: 0,
  //       4: 0,
  //     });
  //   }
  // };


  const scrollPositions = useRef({});

  useEffect(() => {
    const keys = Object.keys(listRefs.current);
    keys.forEach((key) => {
      const el = listRefs.current[key];
      if (!el) return;
      const handleScroll = () => { scrollPositions.current[key] = el.scrollTop; };
      el.addEventListener("scroll", handleScroll);
      return () => { el.removeEventListener("scroll", handleScroll); };
    });
  }, [sections]);



  useEffect(() => {
    Object.keys(listRefs.current).forEach((key) => {
      const el = listRefs.current[key];
      if (el && scrollPositions.current[key] !== undefined) {
        el.scrollTop = scrollPositions.current[key];
      }
    });
  });

  const toggleSelect = (section, type, id) => {
    const key = `${section}-${type}`;
    preserveScroll(key, () => {
      setSections((prev) => ({
        ...prev, [section]: {
          ...prev[section], [type]: prev[section][type].map((item) =>
            item.id === id ? { ...item, selected: !item.selected } : item
          ),
        },
      }));
    });
  };


  // const toggleSelect = (section, type, id) => {
  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: {
  //       ...prev[section],
  //       [type]: prev[section][type].map((item) =>
  //         item.id === id ? { ...item, selected: !item.selected } : item
  //       ),
  //     },
  //   }));
  // };

  const handleSave = () => {
    let authData = getAuthProps();
    const formValues = editCriteriaRefs.current?.getFormData();
    if (!formValues) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }

    const requirementList = [
      ...sections["Section A"].assigned.map((item) => ({ RequirementId: item.id, SectionId: 1, UpdatedBy: 115, UpdatedAppId: authData?.adminUserId, CriteriaId: editID })),
      ...sections["Section B"].assigned.map((item) => ({ RequirementId: item.id, SectionId: 2, UpdatedBy: 115, UpdatedAppId: authData?.adminUserId, CriteriaId: editID })),
      ...sections["Section C"].assigned.map((item) => ({ RequirementId: item.id, SectionId: 3, UpdatedBy: 115, UpdatedAppId: authData?.adminUserId, CriteriaId: editID })),
    ];


    const request = {
      CriteriaId: editID,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      CriteriaName: formValues?.criteriaName || null,
      Rating1Tick: Number(ratings[1]) ?? null,
      Rating2Tick: Number(ratings[2]) ?? null,
      Rating3Tick: Number(ratings[3]) ?? null,
      Rating4Tick: Number(ratings[4]) ?? null,
      UpdateRequirementList: requirementList,
      StatusId: 3
    };
    submitCriteria(request);
  };


  const renderList = (section, type, list) =>
    list?.map((item) => (
      <li key={item.id}>
        <input
          type="checkbox"
          checked={item.selected || false}
          onChange={() => toggleSelect(section, type, item.id)}
        />
        <span>{item.name}</span>
      </li>
    ));



  // const minLen = sections?.["Section C"]?.assigned?.length ?? 0;
  // const total = Object.values(ratings).reduce((sum, val) => sum + val, 0);
  // const handleChange = (tick, value) => {
  //   const num = Number(value);
  //   if (isNaN(num) || num < 0) return;
  //   const currentTotal = Object.values(ratings).reduce((s, v) => s + v, 0);
  //   const newTotal = currentTotal - ratings[tick] + num;
  //   // Only block if increasing beyond limit
  //   if (num > ratings[tick] && newTotal > minLen) return;
  //   setRatings((prev) => ({
  //     ...prev,
  //     [tick]: num,
  //   }));
  // };
  const minLen = sections?.["Section C"]?.assigned?.length ?? 0;
  const handleChange = (key, value) => {
    if (!/^\d*$/.test(value)) return;

    const cleanedValue = value.replace(/^0+/, "") || "0";
    const num = Number(cleanedValue);
    // const num = Number(value);
    debugger
    if (num > minLen) return;
    // const total = Object.entries(ratings).reduce((sum, [key, val]) => {
    //   if (Number(key) === Number(tick)) {
    //     return sum + num;
    //   }
    //   return sum + Number(val || 0);
    // }, 0);
    // if (total > minLen) return;

    // setRatings((prev) => ({
    //   ...prev,
    //   [tick]: num,
    // }));

    setRatings((prev) => {
      const updated = { ...prev, [key]: num };
      // Validation: enforce increasing order
      for (let i = 2; i <= 4; i++) {
        if (updated[i] !== 0 && updated[i] <= updated[i - 1]) {
          // reject update
          return prev;
        }
      }

      return updated;
    });
  };



  const handleBack = () => {
    navigate("/crudCriteria");
  }

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!criteriaLoading && criteriaData) {
      if (criteriaData?.errorMessage === "Criteria Name Already Exists.") {
        error("Criteria name already exists.")
      }
      else {
        success("Criteria information submitted successfully")
        navigate("/crudCriteria");
      }
    }
  }, [criteriaLoading, criteriaData]);


  return (
    <div className="add-requirement">
      <Suspense fallback={<DataLoader />}>
        <Accordion title="Criteria Information" className="mb-4" button={false} accordion={false}>
          <div className="row">
            <FormCreator ref={editCriteriaRefs} {...formData} onFormFieldValueChange={handleFormFieldChange} />
          </div>

          <div className="requirements-page">
            <Section 
            title="Section A" 
            data={sections["Section A"]} 
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
            />



            <Section 
            title="Section B"
            data={sections["Section B"]}
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
             />


            <Section 
            title="Section C" 
            data={sections["Section C"]} 
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
            />
          </div>

          <div className="sectionC-info">
            <div className="sectionC-header">
              <h3>Section C Additional Information</h3>
            </div>

            <div className="rating-container">
              <p className="rating-title">Rating</p>
              {[1, 2, 3, 4].map((tick) => (
                <div className="rating-row" key={tick}>
                  <span className="rating-label">{tick} Tick</span>
                  <input
                    type="text"
                    className="rating-input"
                    value={ratings[tick]}
                    // disabled={total >= minLen && ratings[tick] === 0}
                    // disabled={total >= minLen && ratings[tick] == 0}
                    onChange={(e) => handleChange(tick, e.target.value)}
                  />

                  <span className="rating-total">/{minLen || "N.A"}</span>
                </div>
              ))}
            </div>
          </div>
        </Accordion>

        <div className="add-criteria-btn-wrapper">
          <Buttons buttonText="Back" buttonTypeClassName="btn btn-secondary mb-2" onClick={handleBack} />
          {/* <Buttons buttonText="Download PDF" buttonTypeClassName="orange-btn" /> */}
          <Buttons buttonText="Save" buttonTypeClassName="add-btn"
            onClick={handleSave}
            isDisable={criteriaLoading}
          />
          <Buttons buttonText="Approve" buttonTypeClassName="approve-btn" isDisable={true} />
        </div>
      </Suspense>
    </div>
  );
};

export default EditCriteria;